import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const RELIGION_METRICS_AU = [
  {
    groupMetricId: '110',
    groupMetricSize: 33,
    metricId: '1153',
    displayName: 'Religion: Buddhism',
    definition:
      'The percentage breakdown of residents with the religious denomination Buddhism in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1154',
    displayName: 'Religion: Hinduism',
    definition:
      'The percentage breakdown of residents with the religious denomination Hinduism in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1155',
    displayName: 'Religion: Inadequate Description',
    definition:
      'The percentage breakdown of residents with the religious denomination Inadequate Description in the geographical area.',
  },
  {
    metricId: '1156',
    displayName: 'Religion: Islam',
    definition:
      'The percentage breakdown of residents with the religious denomination Islam in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1157',
    displayName: 'Religion: Judaism',
    definition:
      'The percentage breakdown of residents with the religious denomination Judaism in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1158',
    displayName: 'Religion: No Religion',
    definition:
      'The percentage breakdown of residents with the religious denomination No Religion in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1159',
    displayName: 'Religion: Not Stated',
    definition:
      'The percentage breakdown of residents with the religious denomination Not Stated in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1160',
    displayName: 'Religion: Aboriginal Traditional',
    definition:
      'The percentage breakdown of residents with the religious denomination Aboriginal Traditional Religion in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1161',
    displayName: 'Religion: Other',
    definition:
      'The percentage breakdown of residents with the religious denomination Other in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1162',
    displayName: 'Religion: Overseas Visitor',
    definition:
      'The percentage breakdown of residents with the religious denomination Overseas Visitor in the geographical area.',
  },
  {
    metricId: '1163',
    displayName: 'Religion: Anglican',
    definition:
      'The percentage breakdown of residents with the religious denomination Anglican in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1164',
    displayName: 'Religion: Baptist',
    definition:
      'The percentage breakdown of residents with the religious denomination Baptist in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1165',
    displayName: 'Religion: Brethren',
    definition:
      'The percentage breakdown of residents with the religious denomination Brethren in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1166',
    displayName: 'Religion: Catholic',
    definition:
      'The percentage breakdown of residents with the religious denomination Catholic in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1167',
    displayName: 'Religion: Church of Christ',
    definition:
      'The percentage breakdown of residents with the religious denomination Church of Christ in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1168',
    displayName: 'Religion: Jehovahs Witness',
    definition:
      'The percentage breakdown of residents with the religious denomination Jehovahs Witness in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1169',
    displayName: 'Religion: Latter Day Saints',
    definition:
      'The percentage breakdown of residents with the religious denomination Latter Day Saints in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1170',
    displayName: 'Religion: Lutheran',
    definition:
      'The percentage breakdown of residents with the religious denomination Lutheran in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1171',
    displayName: 'Religion: Oriental Christ',
    definition:
      'The percentage breakdown of residents with the religious denomination Oriental Christ in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1172',
    displayName: 'Religion: Orthodox',
    definition:
      'The percentage breakdown of residents with the religious denomination Orthodox in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1173',
    displayName: 'Religion: Other Christian',
    definition:
      'The percentage breakdown of residents with the religious denomination Other Christian in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1174',
    displayName: 'Religion: Other Protestant',
    definition:
      'The percentage breakdown of residents with the religious denomination Other Protestant in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1175',
    displayName: 'Religion: Pentecostal',
    definition:
      'The percentage breakdown of residents with the religious denomination Pentecostal in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1176',
    displayName: 'Religion: Presbyterian and Reformed',
    definition:
      'The percentage breakdown of residents with the religious denomination Presbyterian in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1177',
    displayName: 'Religion: Salvation Army',
    definition:
      'The percentage breakdown of residents with the religious denomination Salvation Army in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1178',
    displayName: 'Religion: Seventh Day Adventist',
    definition:
      'The percentage breakdown of residents with the religious denomination Seventh Day Adventist in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1179',
    displayName: 'Religion: Uniting Church',
    definition:
      'The percentage breakdown of residents with the religious denomination Uniting Church in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1302',
    displayName: 'Religion: Assyrian Apostolic',
    definition:
      'The percentage breakdown of residents with the religious denomination Assyrian Apostolic in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1303',
    displayName: 'Religion: Christianity, nfd',
    definition:
      'The percentage breakdown of residents with the religious denomination Christian in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1304',
    displayName: 'Religion: Other spiritual beliefs',
    definition:
      'The percentage breakdown of residents with the religious denomination Other Spirtual Beliefs in the geographical area. This metric is available in 2016, 2021.',
  },
  {
    metricId: '1305',
    displayName: 'Religion: Secular Beliefs',
    definition:
      'The percentage breakdown of residents with the religious denomination Secular Beliefs in the geographical area. This metric is available in 2016, 2021.',
  },
  {
    metricId: '1306',
    displayName: 'Religion: Sikhism',
    definition:
      'The percentage breakdown of residents with the religious denomination Sikhism in the geographical area. This metric is available in 2016, 2021.',
  },
  {
    metricId: '1307',
    displayName: 'Religion: Christianity',
    definition:
      'The percentage breakdown of residents with the religious denomination Total Christian in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    groupMetricId: ' ',
    groupMetricSize: 1,
    metricId: '1308',
    displayName: 'Religion: Other Religions',
    definition:
      'The percentage breakdown of residents with the religious denomination Total Other in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    groupMetricId: ' ',
    groupMetricSize: 1,
    metricId: '1309',
    displayName:
      ' Religion: Secular Beliefs, Other Spiritual Beliefs, No Religious Affiliation ',
    definition:
      'The percentage breakdown of residents with the religious denomination Total Secular Beliefs in the geographical area. This metric is available in 2016, 2021.',
  },
];

export const ReligionMetrics = () => {
  const country = useRootStore(state => state.country);

  const metrics = [
    {
      title: 'Religion',
      data: country === 'au' ? RELIGION_METRICS_AU : [],
    },
  ];

  if (country === 'nz') return null;

  return (
    <div>
      <Typography id="religion-metrics" variant="h6" fontWeight={600} my={0.5}>
        Religion Metrics
      </Typography>

      <Typography variant="body2">
        The Religion Metrics relate to the breakdown of religions of the
        residents in a particular location.
      </Typography>

      <br />

      <Stack gap={4}>
        {metrics
          .filter(metric => metric.data.length > 0)
          .map(metric => (
            <div>
              <Typography variant="body2" fontWeight={600}>
                {metric.title}
              </Typography>

              <br />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ whiteSpace: 'nowrap' }}>
                    <TableRow>
                      <TableCell>Group Metric ID</TableCell>
                      <TableCell>Metric ID</TableCell>
                      <TableCell>Display Name</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metric.data.map(data => (
                      <TableRow key={data.metricId}>
                        {data.groupMetricId && (
                          <TableCell
                            rowSpan={data.groupMetricSize || metric.data.length}
                          >
                            {data.groupMetricId}
                          </TableCell>
                        )}
                        <TableCell>{data.metricId}</TableCell>
                        <TableCell>{data.displayName}</TableCell>
                        <TableCell>{data.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
      </Stack>
    </div>
  );
};
